import { render, staticRenderFns } from "./EditTabPanel.vue?vue&type=template&id=3d0926a1&scoped=true"
import script from "./EditTabPanel.vue?vue&type=script&lang=js"
export * from "./EditTabPanel.vue?vue&type=script&lang=js"
import style0 from "./EditTabPanel.vue?vue&type=style&index=0&id=3d0926a1&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0926a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0926a1')) {
      api.createRecord('3d0926a1', component.options)
    } else {
      api.reload('3d0926a1', component.options)
    }
    module.hot.accept("./EditTabPanel.vue?vue&type=template&id=3d0926a1&scoped=true", function () {
      api.rerender('3d0926a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/task/EditTabPanel.vue"
export default component.exports